var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"calendar-view"},_vm._l((12),function(month){return _c('div',{key:_vm.dateDisplay
        .clone()
        .month(month - 1)
        .format('YYYY-MM-DD'),staticClass:"grid-container"},[_c('div',{staticClass:"header"},[_c('labelc',{attrs:{"type":"header","text":_vm.dateDisplay
            .clone()
            .month(month - 1)
            .format('MMMM')}})],1),_c('div',{staticClass:"header-day"},[_c('labelc',{attrs:{"type":"day","text":"M"}}),_c('labelc',{attrs:{"type":"day","text":"T"}}),_c('labelc',{attrs:{"type":"day","text":"W"}}),_c('labelc',{attrs:{"type":"day","text":"T"}}),_c('labelc',{attrs:{"type":"day","text":"F"}}),_c('labelc',{attrs:{"type":"day","text":"S"}}),_c('labelc',{attrs:{"type":"day","text":"S"}})],1),_c('div',{staticClass:"grid"},_vm._l((_vm.dateDisplay
          .clone()
          .month(month - 1)
          .daysInMonth()),function(day,index){return _c('day',{key:_vm.dateDisplay
            .clone()
            .month(month - 1)
            .date(day)
            .format('YYYY-MM-DD'),attrs:{"date":_vm.dateDisplay
            .clone()
            .month(month - 1)
            .date(day),"date-selected":_vm.date},on:{"click":function($event){_vm.DateSelectionUpdate(
            _vm.dateDisplay
              .clone()
              .month(month - 1)
              .date(day)
          )}}})}),1)])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }